import React,{useState} from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

const Layout = ({ source }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    return (
        <div>
            <Header source={source} />
            <div className="d-flex">
                <Sidebar source={source} callingFrom={'layout'} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed}/>
                <div className={
                    source === "sdm"
                      ? "content toplinesdm"
                      : source === "permit-dashboard"
                      ? isCollapsed
                        ? "content permit-dashboard-wrp expanded"
                        : "content permit-dashboard-wrp"
                      : "content portalAdmin"
                  }>
                    <Outlet />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Layout;
